import React, { useState, useEffect, useMemo } from "react";
import "@ant-design/compatible/assets/index.css";
import _ from "lodash";
import { Form, Button, Select } from "antd";
import { mypRoles } from "../../../utils/mappingData";
import { GeneralInfo, HotelMapping, RoleMapping } from ".";
import PermissionSelection from "./PermissionSelection";
import ActivationSelection from "./ActivationSection";
import { initialValues } from "../../UserPermission/Utils/Utils";
import SSOSelection from "./SSOSelection/SSOSelection";

const { Option } = Select;

const validateUserName = (rule, value, callback) => {
  if (value !== undefined && value.indexOf(" ") !== -1) {
    callback("Please Remove Spaces");
  } else if (/[A-Z]/.test(value)) {
    callback("Please Enter Lowercase Letters");
  } else {
    callback();
  }
};

const UserCreateForm = ({
  onSubmit,
  formData,
  onFinishFailed,
  onFinish,
  rolesGetData,
  mainRolesGetData,
  onMainRoleChange,
  onMainRoleSelect,
  hotelGetData,
  hmgMainGetData,
  initialValue,
  createStatus,
  current,
  next,
  prev,
  steps,
  defaultPermissionOnChange,
  disabledState,
  permissionSetIntialValues,
  indexPermissions,
  setIndexPermission,
  indexList,
  additionalParameters,
  accessPermissions,
  onRoleChange,
  createdUser,
  setInitialState,
  isAdmin,
  indexPermissionHandler,
  hmgPermissionUpdate,
  assignHotelsHandler,
  userId,
  applicationData,
  applicationRolesList,
  ...props
}) => {
  const [allHotelsForCorporate] = useState("");

  const [form] = Form.useForm();
  const { getFieldValue, setFieldsValue } = form;
  useEffect(() => {
    formData(form);
  }, []);
  const hmgMainGetOptions = hmgMainGetData.map((d) => (
    <Option key={d._id}>{d.hmg_name}</Option>
  ));

  const hotelSubmitNext = useMemo(() => {
    const myDocs = getFieldValue("my_docs_solution_access");
    const compliance = getFieldValue("compliance_solution_access");
    const ulp = getFieldValue("ulp_solution_access");
    const qms = getFieldValue("qms_solution_access");
    const settings = getFieldValue("settings_app_solution_access");
    const myp = getFieldValue("myp_solution_access");

    const hasUserEnabled = compliance || ulp || qms || settings || myp;
    const isSubmitButtonDisabled =
      (myDocs || hasUserEnabled) && !props?.assignedHotels?.length && process.env.REACT_APP_PLATFORM_TYPE === "GENERIC";

    if ((isAdmin && current === 4) || (!isAdmin && current === 3)) {
      return (
        <Button
          type="primary"
          htmlType="submit"
          disabled={isSubmitButtonDisabled}
        >
          Next
        </Button>
      );
    }
  }, [current, props.assignedHotels, isAdmin]);

  return (
    <div style={{ textAlign: "left" }}>
      <Form
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          status: 1,
          use_mfa: false,
          myp_user: false,
          ...initialValues,
        }}
      >
        <div
          style={
            current > 0 && current < 5
              ? { display: "block", fontSize: 20 }
              : { display: "none", fontSize: 20 }
          }
        >
          {getFieldValue("user_name")}
        </div>
        <div style={current === 0 ? { display: "block" } : { display: "none" }}>
          <GeneralInfo
            getFieldValue={getFieldValue}
            validateUserName={validateUserName}
          />
        </div>
        <div style={current === 1 ? { display: "block" } : { display: "none" }}>
          <RoleMapping
            getFieldValue={getFieldValue}
            rolesGetData={rolesGetData}
            mainRolesGetData={mainRolesGetData}
            hmgMainGetOptions={hmgMainGetOptions}
            mypRoles={mypRoles}
            onMainRoleChange={onMainRoleChange}
            onMainRoleSelect={onMainRoleSelect}
            accessPermissions={accessPermissions}
            onRoleChange={onRoleChange}
          />
        </div>
        { isAdmin && (
          <div style={current === 2 ? { display: "block" } : { display: "none" }}>
            <SSOSelection
              getFieldValue={getFieldValue}
              applicationData={applicationData}
              applicationPermissionIndexes={
                initialValue?.app_roles ? initialValue.app_roles : []
              }
              setFieldsValue={setFieldsValue}
              applicationRolesList={applicationRolesList}
            />
          </div>
        )}
        <div
          style={
            (isAdmin && current === 3) || (!isAdmin && current === 2)
              ? { display: "block" }
              : { display: "none" }
          }
          className="is_form_2"
        >
          <PermissionSelection
            Form={Form}
            current={current}
            mypRoles={mypRoles}
            defaultPermissionOnChange={defaultPermissionOnChange}
            disabledState={disabledState}
            permissionSetIntialValues={permissionSetIntialValues}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            indexPermissions={indexPermissions}
            setIndexPermission={setIndexPermission}
            hmgPermissionUpdate={hmgPermissionUpdate}
            indexList={indexList}
            isAdmin={isAdmin}
            additionalParameters={additionalParameters}
            indexPermissionHandler={indexPermissionHandler}
          />
        </div>
        <div
          style={
            (isAdmin && current === 4) || (!isAdmin && current === 3)
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <div>
            <HotelMapping
              hotelGetData={hotelGetData}
              initialValue={initialValue}
              form={form}
              checkUserUsesHotel={props.checkUserUsesHotel}
              finish={props.finish}
              allHotelsForCorporate={allHotelsForCorporate}
              createStatus={createStatus}
              mainRolesGetData={mainRolesGetData}
              hmgMainGetData={hmgMainGetData}
              mainRoleId={getFieldValue("main_role")}
              corporateUserHmgId={getFieldValue("corporate_user_hmg")}
              assignHotelsHandler={assignHotelsHandler}
            />
          </div>
        </div>
        <div
          style={
            (isAdmin && current === 5) || (!isAdmin && current === 4)
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <div>
            <ActivationSelection
              hotelGetData={hotelGetData}
              initialValue={initialValue}
              form={form}
              checkUserUsesHotel={props.checkUserUsesHotel}
              finish={props.finish}
              allHotelsForCorporate={allHotelsForCorporate}
              createStatus={createStatus}
              createdUserDetails={createdUser}
              current={current}
              goToFirst={setInitialState}
            />
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          {current > 0 &&
          ((isAdmin && current < 5) || (!isAdmin && current < 4)) ? (
            <Button
              onClick={prev}
              style={{ marginRight: 8 }}
              onKeyPress={(e) => (e.key === "Enter" ? e.preventDefault() : "")}
            >
              Previous
            </Button>
          ) : null}
          {(isAdmin && current < 4) || (!isAdmin && current < 3) ? (
            <Button
              type="primary"
              onClick={next}
              onKeyPress={(e) => (e.key === "Enter" ? e.preventDefault() : "")}
            >
              Next
            </Button>
          ) : null}
          {hotelSubmitNext}
        </div>
      </Form>
    </div>
  );
};
export default UserCreateForm;
